import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

interface LinkedPlanTemplatesPayload {
  template_ids: number[];
}

export const useAddPlanTemplatesQuery = (id?: string) => {
  const { mutateAsync } = useMutation((payload: LinkedPlanTemplatesPayload) =>
    api.patch(API_URL.TEMPLATES_ORGANIZATIONS_LINKED_TEMPLATES_BY_ORGANIZATION_ID(id || ''), payload)
  );
  return mutateAsync;
};

export default useAddPlanTemplatesQuery;
